import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import Thunk from 'redux-thunk';
import ReduxPromise from 'redux-promise';
import reducers from './reducers';
import App from './components/App';
import './common/utils/ConfigureAxiosUtils';

const createStoreWithMiddleware = createStore(reducers, compose(applyMiddleware(Thunk, ReduxPromise)));

export default function (mountPoint) {
    ReactDOM.render(
        <Provider store={createStoreWithMiddleware}>
            <App />
        </Provider>
        , mountPoint
    );
}
